import type { FC, PropsWithChildren } from 'react';

export const composeProviders = (...providers: Array<FC<PropsWithChildren>>) =>
  function Providers({ children }: PropsWithChildren) {
    return (
      <>
        {providers.reduceRight(
          (accumulated, Provider) => (
            <Provider>{accumulated}</Provider>
          ),
          children,
        )}
      </>
    );
  };
